export default __webpack_public_path__ + "static/media/product-4.41644bf5.png";